import React, { createContext, useContext, useMemo, useState, type ComponentProps } from 'react';
import { Alert } from 'antd';

type SelfRegistrationAlert = { message: string } & ComponentProps<typeof Alert>;

const RegistrationAlertContext = createContext<{
  alert: SelfRegistrationAlert | undefined;
  setAlert: (alert: SelfRegistrationAlert | undefined) => void;
}>({
  alert: undefined,
  setAlert: () => {}
});

export const RegistrationAlertProvider = ({ children }: { children: React.ReactNode }) => {
  const [alert, setAlert] = useState<SelfRegistrationAlert | undefined>();

  return (
    <RegistrationAlertContext.Provider value={useMemo(() => ({ alert, setAlert }), [alert, setAlert])}>
      {children}
    </RegistrationAlertContext.Provider>
  );
};

export const useRegistrationAlert = () => useContext(RegistrationAlertContext);
